import * as React from 'react'
import image from './background.jpg'

export const divStyle: React.CSSProperties = {
  backgroundImage: `url(${image})`,
  backgroundSize: 'cover'
}
